import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import form from './form';
import auth from './auth';
import cookieNotic from './cookie-notic';
import user from './user';
import applications from './applications';
import changes from './changes-modal';
import partnersDbParams from './partners-database';
import ratingTable from './ratingTable';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createPersistedState()],
  modules: {
    form,
    auth,
    user,
    applications,
    changes,
    cookieNotic,
    partnersDbParams,
    ratingTable,
  },
});
